import { Pipe, PipeTransform } from "@angular/core";
import { interval } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Pipe({
  name: "durationtest",
})
export class DurationPipe implements PipeTransform {
  transform(start: string | Date, end?: string | Date) {
    const startDate = new Date(start);
    const endDate = end ? new Date(end) : null;

    return interval(1000).pipe(
      startWith(0),
      map(() => {
        const now = endDate ?? new Date();
        const diff = Math.max(0, now.getTime() - startDate.getTime());

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      })
    );
  }
}
